import RadarIcon from "@mui/icons-material/Radar";

const dashboard = {
  id: "group-dashboard",
  title: "Dashboard",
  type: "group",
  children: [
    {
      id: "dashboard",
      title: "Radar",
      type: "item",
      url: "/radar",
      icon: RadarIcon,
    },
  ],
};

export default dashboard;
